<div id="content" class="allcp-form" ng-controller="DashboardController" ng-init="init()">
    <header class="navbar navbar-fixed-top mw90">
        <div class="navbar-logo-wrapper">
            <a class="navbar-logo-text" href="/" ng-click="mainPage()">
                <img src="img/logo-icon.svg" alt="Hodxpress.com">
            </a>
        </div>
    </header>
    <div class="row dashboard">

        <div class="col-md-6">
            <div class="panel panel-white bg-system ptn" style="min-height: 525px;">
                <div class="loading" ng-if="loadingWork">
                    <div id="global_loader" class="glb-ldr-prt"><div class="gl-ldr-cld"><div class="gl-ldr-ctr"><div class="gl-loader"></div></div></div></div>
                </div>
                <div class="panel-body pn">
                    <h5 style="color:#fff">Bugün</h5>
                    <table class="table mbn tc-icon-bold br-t">
                        <thead>
                            <th class="text-center"><span class="fa fa-circle text-default fs14 mr10"></span> Toplam</th>
                            <th class="text-center"><span class="fa fa-circle text-primary fs14 mr10"></span> Bekleyen</th>
                            <th class="text-center"><span class="fa fa-circle text-danger fs14 mr10"></span> İptal</th>
                            <th class="text-center"><span class="fa fa-circle text-success fs14 mr10"></span> Tamamlanan</th>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="va-m fw600 text-center">
                                    <a href="#" class="text-default">{{ data.today.total }}</a>
                                </td>
                                <td class="va-m fw600 text-center">
                                    <a href="#" class="text-primary">{{ data.today.other }}</a>
                                </td>
                                <td class="va-m fw600 text-center">
                                    <a href="#" class="text-danger">{{ data.today.fail }}</a>
                                </td>
                                <td class="va-m fw600 text-center">
                                    <a href="#" class="text-success">{{ data.today.success }}</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="panel-body pn">
                    <h5 style="color:#fff">Bu Hafta</h5>
                    <table class="table mbn tc-icon-bold br-t">
                        <thead>
                            <th class="text-center"><span class="fa fa-circle text-default fs14 mr10"></span> Toplam</th>
                            <th class="text-center"><span class="fa fa-circle text-primary fs14 mr10"></span> Bekleyen</th>
                            <th class="text-center"><span class="fa fa-circle text-danger fs14 mr10"></span> İptal</th>
                            <th class="text-center"><span class="fa fa-circle text-success fs14 mr10"></span> Tamamlanan</th>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="va-m fw600 text-center">
                                    <a href="#" class="text-default">{{ data.week.total }}</a>
                                </td>
                                <td class="va-m fw600 text-center">
                                    <a href="#" class="text-primary">{{ data.week.other }}</a>
                                </td>
                                <td class="va-m fw600 text-center">
                                    <a href="#" class="text-danger">{{ data.week.fail }}</a>
                                </td>
                                <td class="va-m fw600 text-center">
                                    <a href="#" class="text-success">{{ data.week.success }}</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="panel-body pn">
                    <table class="table mbn tc-icon-bold br-t">
                    <h5 style="color:#fff">Bu Ay</h5>
                        
                        <thead>
                            <th class="text-center"><span class="fa fa-circle text-default fs14 mr10"></span> Toplam</th>
                            <th class="text-center"><span class="fa fa-circle text-primary fs14 mr10"></span> Bekleyen</th>
                            <th class="text-center"><span class="fa fa-circle text-danger fs14 mr10"></span> İptal</th>
                            <th class="text-center"><span class="fa fa-circle text-success fs14 mr10"></span> Tamamlanan</th>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="va-m fw600 text-center">
                                    <a href="#" class="text-default">{{ data.month.total }}</a>
                                </td>
                                <td class="va-m fw600 text-center">
                                    <a href="#" class="text-primary">{{ data.month.other }}</a>
                                </td>
                                <td class="va-m fw600 text-center">
                                    <a href="#" class="text-danger">{{ data.month.fail }}</a>
                                </td>
                                <td class="va-m fw600 text-center">
                                    <a href="#" class="text-success">{{ data.month.success }}</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="col-md-6">
            <div class="panel panel-white ptn" style="min-height: 525px;">
                <div class="loading" ng-if="loadingWork">
                    <div id="global_loader" class="glb-ldr-prt"><div class="gl-ldr-cld"><div class="gl-ldr-ctr"><div class="gl-loader"></div></div></div></div>
                </div>
                <div class="panel-body pn">
                    <h5>Son Hareketler</h5>
                    <div ng-repeat="log in data.logs">
                        <div class="col-md-1 mt50">
                            <a href="#" ng-click="getOrderDetails(log.order)">#{{ log.order_id }}</a>
                        </div>
                        <div class="col-md-11">
                            <div class="activity-item">
                                <div class="panel pn">
                                    <div class="panel-body p20 pt10 pb10">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <i class="fa fa-clock-o"></i> 
                                                {{ log.created_at | amUtc | amDateFormat:'MM/DD/YYYY' }},
                                                {{ log.created_at | amUtc | amDateFormat:'HH:mm' }}
                                                <hr class="m5">
                                            </div>
                                            <div class="col-md-12" ng-if="log.proccess == 'rate'">
                                                <p>
                                                    Müşteri tarafından <i class="fa fa-star"></i> {{ selectedWork.rate }} Puan verildi. <br>
                                                    <strong>Yorum : {{ log.reason ? log.reason : 'Yorum Yapılmadı.' }}</strong>
                                                </p>
                                            </div>

                                            <div class="col-md-12" ng-if="log.proccess == 'edit'">
                                                <span><strong>{{ log.user.full_name }}</strong> tarafından iş bilgileri <strong>güncellendi.</strong> </span> 
                                            </div>

                                            <div 
                                                class="col-md-12" 
                                                ng-if="
                                                    log.proccess != 'edit' && 
                                                    log.proccess != 'rate' && 
                                                    log.proccess != 'create' && 
                                                    log.proccess != 'change_date' &&
                                                    log.proccess != 'change_worker' &&
                                                    log.proccess != 'assign_worker' &&
                                                    log.proccess != 'sending_sms' &&
                                                    log.proccess != 'call_record' &&
                                                    log.proccess != 'waiting_start' &&
                                                    log.proccess != 'waiting_end' &&
                                                    log.proccess != 'change_order_fields'
                                            ">
                                                <span><strong>{{ log.user.full_name }}</strong> tarafından iş durumu </span> 
                                                <strong 
                                                    ng-if="log.status" 
                                                    ng-style="{'color': log.status.color }">
                                                    "{{ log.status.name }}"
                                                </strong>
                                                <span>olarak değiştirildi. </span> 
                                                <span ng-if="log.status.value == 'fail'">
                                                    <br /><strong>İptal Nedeni : </strong>   {{ log.reason ? log.reason : '-' }}
                                                </span> 
                                            </div>

                                            <div class="col-md-12" ng-if="log.proccess == 'create'">
                                                <span><strong>{{ log.user.full_name }}</strong> tarafından kargo <strong>oluşturuldu</strong>. </span> 
                                            </div>

                                            <div class="col-md-12" ng-if="log.proccess == 'change_date'">
                                                <span><strong>{{ log.user.full_name }}</strong> tarafından <strong>kargo tarihi değiştirildi</strong>. </span> 
                                                <br />
                                                <strong>Değiştirme Nedeni : </strong>   {{ log.reason ? log.reason : '-' }}
                                            </div>

                                            <div class="col-md-12" ng-if="log.proccess == 'change_worker'">
                                                <span><strong>{{ log.user.full_name }}</strong> tarafından <strong>kargo devredildi.</strong>. </span> 
                                                <br />
                                                <strong>Devretme Nedeni : </strong>   {{ log.reason ? log.reason : '-' }}
                                            </div>
                                            <div class="col-md-12" ng-if="log.proccess == 'assign_worker'">
                                                <span><strong>{{ log.user.full_name }}</strong> tarafından kargo <strong>{{ log.worker.full_name }}</strong> kişisine <strong>Created.</strong>. </span> 
                                                <hr class="m5">
                                            </div>
                                            <div class="col-md-12" ng-if="log.proccess == 'sending_sms'">
                                                <span><strong>{{ log.user.full_name }}</strong> tarafından <strong> sms gönderildi.</strong>. </span> 
                                                <br />
                                                {{ log.reason ? log.reason : '-' }}
                                            </div>
                                            <div class="col-md-12" ng-if="log.proccess == 'call_record'">
                                                <span><strong>{{ log.user.full_name }}</strong> tarafından <strong> Çağrı Kaydı eklendi.</strong>. </span> 
                                                <br />
                                                <strong>Çağrı Detayı : </strong> {{ log.reason ? log.reason : '-' }}
                                            </div>
                                            <div class="col-md-12" ng-if="log.proccess == 'waiting_start'">
                                                <span><strong>{{ log.user.full_name }}</strong> tarafından <strong> kargo bekleme durumuna alındı.</strong>. </span> 
                                                <br />
                                                {{ log.reason ? log.reason : '-' }}
                                            </div>
                                            <div class="col-md-12" ng-if="log.proccess == 'waiting_end'">
                                                <span><strong>{{ log.user.full_name }}</strong> tarafından <strong> kargo bekleme durumundan çıkarıldı.</strong>. </span> 
                                                <br />
                                                {{ log.reason ? log.reason : '-' }}
                                            </div>

                                            <div class="col-md-12" ng-if="log.proccess == 'change_order_fields'">
                                                <span><strong>{{ log.user.full_name }}</strong> tarafından <strong>kargo özel alanı değiştirildi.</strong>. </span> 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="timeline-item" ng-if="selectedWork.logs.length == 0">
                            <div class="timeline-icon">
                                <span class="fa fa-times"></span>
                            </div>
                            <div class="panel">
                                <div class="panel-body p20 pt10 pb10">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <span>Henüz Aktivite Bulunamadı!</span> 
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row p20">
        <div class="col-md-6" ng-init="ordersFromFilter('','all','allOrders', 'loadingAllOrdersBox')">
            <div class="panel panel-white dashboard-min-height ptn">
                <div class="loading" ng-if="loadingAllOrdersBox">
                    <div id="global_loader" class="glb-ldr-prt"><div class="gl-ldr-cld"><div class="gl-ldr-ctr"><div class="gl-loader"></div></div></div></div>
                </div>
                <div class="panel-body pn">
                    <h5 class="mt20">Tüm İşler</h5> 
                    <div class="pull-right" style="margin-top: -30px;">
                        <a href="#" ng-click="ordersFromFilter('day','all','allOrders', 'loadingAllOrdersBox')" class="btn btn-success btn-xs">Bugün</a>
                        <a href="#" ng-click="ordersFromFilter('week','all','allOrders', 'loadingAllOrdersBox')" class="btn btn-success btn-xs">Bu Hafta</a>
                        <a href="#" ng-click="ordersFromFilter('month','all','allOrders', 'loadingAllOrdersBox')" class="btn btn-success btn-xs">Bu Ay</a>
                        <a href="#" ng-click="ordersFromFilter('','all','allOrders', 'loadingAllOrdersBox')" class="btn btn-success btn-xs">Tümü</a>
                    </div>
                    <div class="row ">
                        <div ng-repeat="order in allOrders">
                            <div class="col-md-1 mt50">
                                <a href="#" ng-click="getOrderDetails(order)">#{{ order.id }}</a>
                            </div>
                            <div class="col-md-11">
                                <div class="activity-item" ng-style="{'border-color': order.status.color }">
                                    <div class="panel pn">
                                        <div class="panel-body p20 pt10 pb10">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <i class="fa fa-clock-o"></i> 
                                                    {{ order.created_at | amUtc | amDateFormat:'MM/DD/YYYY' }},
                                                    {{ order.created_at | amUtc | amDateFormat:'HH:mm' }}
                                                    <strong>{{ humanizeDuration(order.time) }}</strong>
                                                    <span ng-style="{'background-color': order.status.color }"
                                                        ng-if="order.status"
                                                        class="order-list-status pull-right">{{ order.status.name }}
                                                    </span>
                                                    <span ng-if="!order.status" 
                                                            class="pull-right">
                                                        Created
                                                    </span>
                                                    <hr class="m5">
                                                </div>
                                                <div class="col-md-12">
                                                    <a href="#" ng-click="getCustomerDetails(order.customer.id)">{{ order.customer.customer_name }}</a>
                                                </div>
                                                <div class="col-md-12">
                                                    <a href="#" ng-click="getWorkerDetails(order.worker.id)">{{ order.worker.full_name }}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="timeline-item" ng-if="allOrders.length == 0">
                            <div class="panel">
                                <div class="panel-body pt10 pb10">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <span>KargoBulunamadı!</span> 
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="show-more" ng-if="false">
                <a href="#" ng-click="showMore('all','allOrders','loadingAllOrdersBox')" class="text-center">Daha Fazla Göster</a>
            </div>
        </div>

        <div class="col-md-6" ng-init="ordersFromFilter('','pending','pendingOrders', 'loadingpendingOrdersBox')">
            <div class="panel panel-white dashboard-min-height ptn">
                <div class="loading" ng-if="loadingpendingOrdersBox">
                    <div id="global_loader" class="glb-ldr-prt"><div class="gl-ldr-cld"><div class="gl-ldr-ctr"><div class="gl-loader"></div></div></div></div>
                </div>
                <div class="panel-body pn">
                    <h5 class="mt20">Bekleyen İşler</h5> 
                    <div class="pull-right" style="margin-top: -30px;">
                        <a href="#" ng-click="ordersFromFilter('day','pending','pendingOrders', 'loadingpendingOrdersBox')" class="btn btn-success btn-xs">Bugün</a>
                        <a href="#" ng-click="ordersFromFilter('week','pending','pendingOrders', 'loadingpendingOrdersBox')" class="btn btn-success btn-xs">Bu Hafta</a>
                        <a href="#" ng-click="ordersFromFilter('month','pending','pendingOrders', 'loadingpendingOrdersBox')" class="btn btn-success btn-xs">Bu Ay</a>
                        <a href="#" ng-click="ordersFromFilter('','pending','pendingOrders', 'loadingpendingOrdersBox')" class="btn btn-success btn-xs">Tümü</a>
                    </div>
                    <div class="row">
                        <div ng-repeat="order in pendingOrders">
                            <div class="col-md-1 mt50">
                                <a href="#" ng-click="getOrderDetails(order)">#{{ order.id }}</a>
                            </div>
                            <div class="col-md-11">
                                <div class="activity-item" ng-style="{'border-color': order.status.color }">
                                    <div class="panel pn">
                                        <div class="panel-body p20 pt10 pb10">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <i class="fa fa-clock-o"></i> 
                                                    {{ order.created_at | amUtc | amDateFormat:'MM/DD/YYYY' }},
                                                    {{ order.created_at | amUtc | amDateFormat:'HH:mm' }}
                                                    <strong>{{ humanizeDuration(order.time) }}</strong>
                                                    <span ng-style="{'background-color': order.status.color }"
                                                        ng-if="order.status"
                                                        class="order-list-status pull-right">{{ order.status.name }}
                                                    </span>
                                                    <span ng-if="!order.status" 
                                                            class="pull-right">
                                                        Created
                                                    </span>
                                                    <hr class="m5">
                                                </div>
                                                <div class="col-md-12">
                                                    <a href="#" ng-click="getCustomerDetails(order.customer.id)">{{ order.customer.customer_name }}</a>
                                                </div>
                                                <div class="col-md-12">
                                                    <a href="#" ng-click="getWorkerDetails(order.worker.id)">{{ order.worker.full_name }}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="timeline-item" ng-if="pendingOrders.length == 0">
                            <div class="panel">
                                <div class="panel-body pt10 pb10">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <span>KargoBulunamadı!</span> 
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-6" ng-init="ordersFromFilter('','completed','completedOrders', 'loadingcompletedOrdersBox')">
            <div class="panel panel-white dashboard-min-height ptn">
                <div class="loading" ng-if="loadingcompletedOrdersBox">
                    <div id="global_loader" class="glb-ldr-prt"><div class="gl-ldr-cld"><div class="gl-ldr-ctr"><div class="gl-loader"></div></div></div></div>
                </div>
                <div class="panel-body pn">
                    <h5 class="mt20">Tamamlanan İşler</h5> 
                    <div class="pull-right" style="margin-top: -30px;">
                        <a href="#" ng-click="ordersFromFilter('day','completed','completedOrders', 'loadingcompletedOrdersBox')" class="btn btn-success btn-xs">Bugün</a>
                        <a href="#" ng-click="ordersFromFilter('week','completed','completedOrders', 'loadingcompletedOrdersBox')" class="btn btn-success btn-xs">Bu Hafta</a>
                        <a href="#" ng-click="ordersFromFilter('month','completed','completedOrders', 'loadingcompletedOrdersBox')" class="btn btn-success btn-xs">Bu Ay</a>
                        <a href="#" ng-click="ordersFromFilter('','completed','completedOrders', 'loadingcompletedOrdersBox')" class="btn btn-success btn-xs">Tümü</a>
                    </div>
                    <div class="row">
                        <div ng-repeat="order in completedOrders">
                            <div class="col-md-1 mt50">
                                <a href="#" ng-click="getOrderDetails(order)">#{{ order.id }}</a>
                            </div>
                            <div class="col-md-11">
                                <div class="activity-item" ng-style="{'border-color': order.status.color }">
                                    <div class="panel pn">
                                        <div class="panel-body p20 pt10 pb10">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <i class="fa fa-clock-o"></i> 
                                                    {{ order.created_at | amUtc | amDateFormat:'MM/DD/YYYY' }},
                                                    {{ order.created_at | amUtc | amDateFormat:'HH:mm' }}
                                                    <strong>{{ humanizeDuration(order.time) }}</strong>
                                                    <span ng-style="{'background-color': order.status.color }"
                                                        ng-if="order.status"
                                                        class="order-list-status pull-right">{{ order.status.name }}
                                                    </span>
                                                    <span ng-if="!order.status" 
                                                            class="pull-right">
                                                        Created
                                                    </span>
                                                    <hr class="m5">
                                                </div>
                                                <div class="col-md-12">
                                                    <a href="#" ng-click="getCustomerDetails(order.customer.id)">{{ order.customer.customer_name }}</a>
                                                </div>
                                                <div class="col-md-12">
                                                    <a href="#" ng-click="getWorkerDetails(order.worker.id)">{{ order.worker.full_name }}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="timeline-item" ng-if="completedOrders.length == 0">
                            <div class="panel">
                                <div class="panel-body pt10 pb10">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <span>KargoBulunamadı!</span> 
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-6" ng-init="ordersFromFilter('','failed','failedOrders', 'loadingfailedOrdersBox')">
            <div class="panel panel-white dashboard-min-height ptn">
                <div class="loading" ng-if="loadingfailedOrdersBox">
                    <div id="global_loader" class="glb-ldr-prt"><div class="gl-ldr-cld"><div class="gl-ldr-ctr"><div class="gl-loader"></div></div></div></div>
                </div>
                <div class="panel-body pn">
                    <h5 class="mt20">İptal Edilen İşler</h5> 
                    <div class="pull-right" style="margin-top: -30px;">
                        <a href="#" ng-click="ordersFromFilter('day','failed','failedOrders', 'loadingfailedOrdersBox')" class="btn btn-success btn-xs">Bugün</a>
                        <a href="#" ng-click="ordersFromFilter('week','failed','failedOrders', 'loadingfailedOrdersBox')" class="btn btn-success btn-xs">Bu Hafta</a>
                        <a href="#" ng-click="ordersFromFilter('month','failed','failedOrders', 'loadingfailedOrdersBox')" class="btn btn-success btn-xs">Bu Ay</a>
                        <a href="#" ng-click="ordersFromFilter('','failed','failedOrders', 'loadingfailedOrdersBox')" class="btn btn-success btn-xs">Tümü</a>
                    </div>
                    <div class="row">
                        <div ng-repeat="order in failedOrders">
                            <div class="col-md-1 mt50">
                                <a href="#" ng-click="getOrderDetails(order)">#{{ order.id }}</a>
                            </div>
                            <div class="col-md-11">
                                <div class="activity-item" ng-style="{'border-color': order.status.color }">
                                    <div class="panel pn">
                                        <div class="panel-body p20 pt10 pb10">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <i class="fa fa-clock-o"></i> 
                                                    {{ order.created_at | amUtc | amDateFormat:'MM/DD/YYYY' }},
                                                    {{ order.created_at | amUtc | amDateFormat:'HH:mm' }}
                                                    <strong>{{ humanizeDuration(order.time) }}</strong>
                                                    <span ng-style="{'background-color': order.status.color }"
                                                        ng-if="order.status"
                                                        class="order-list-status pull-right">{{ order.status.name }}
                                                    </span>
                                                    <span ng-if="!order.status" 
                                                            class="pull-right">
                                                        Created
                                                    </span>
                                                    <hr class="m5">
                                                </div>
                                                <div class="col-md-12">
                                                    <a href="#" ng-click="getCustomerDetails(order.customer.id)">{{ order.customer.customer_name }}</a>
                                                </div>
                                                <div class="col-md-12">
                                                    <a href="#" ng-click="getWorkerDetails(order.worker.id)">{{ order.worker.full_name }}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="timeline-item" ng-if="failedOrders.length == 0">
                            <div class="panel">
                                <div class="panel-body pt10 pb10">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <span>KargoBulunamadı!</span> 
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        
        <div class="col-md-12 mt30" ng-if="false">
            <ul class="nav navbar-nav">
                <strong class="mr20">{{ calendarTitle }}</strong>
                <button
                    style="line-height: 20px;" 
                    class="btn"
                    mwl-date-modifier
                    date="viewDate"
                    decrement="calendarView"
                    ng-click="changeDate()">
                    Önceki 
                </button>
                <button
                    style="line-height: 20px;" 
                    class="btn"
                    mwl-date-modifier
                    date="viewDate"
                    set-to-today
                    ng-click="changeDate()">
                    Şimdi
                </button>
                <button
                    style="line-height: 20px;" 
                    class="btn"
                    mwl-date-modifier
                    date="viewDate"
                    increment="calendarView"
                    ng-click="changeDate()">
                    Sonraki 
                </button>
        
                <label 
                    class="btn" 
                    style="line-height: 20px;" 
                    ng-click="changeCalendarView('month')">Ay</label>
                <label 
                    class="btn" 
                    style="line-height: 20px;" 
                    ng-click="changeCalendarView('week')">Hafta</label>
                <label 
                    class="btn" 
                    style="line-height: 20px;" 
                    ng-click="changeCalendarView('day')">Gün</label>
        
                
            </ul>
            <div class="clearfix"></div>
            <div class="panel p2">
                <div class="panel-body ptn" style="min-height: 10; max-height: 10;padding-left: 0px;">
                    <mwl-calendar
                        events="events"
                        view="calendarView"
                        view-title="calendarTitle"
                        view-date="viewDate"
                        on-event-click="eventClicked(calendarEvent)"
                        on-event-times-changed="eventTimesChanged(calendarEvent); calendarEvent.startsAt = calendarNewEventStart; calendarEvent.endsAt = calendarNewEventEnd"
                        cell-is-open="cellIsOpen"
                        day-view-start="06:00"
                        day-view-end="22:59"
                        day-view-split="30"
                        cell-modifier="modifyCell(calendarCell)"
                        cell-auto-open-disabled="true"
                        on-timespan-click="timespanClicked(calendarDate, calendarCell)">
                    </mwl-calendar>
                </div>
            </div>
        </div>
    </div>
</div>
